import React, { Component, Fragment } from "react";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Dialog,
  DialogTitle,
  Grid,
  Tooltip,
  IconButton,
} from "@material-ui/core/";
import axios from "axios";

import ArchiveIcon from "@material-ui/icons/Archive";
import UnarchiveIcon from "@material-ui/icons/Unarchive";

import { LoggedUserContext } from "../LoggedUserContext";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { acquireToken } from "../adalConfig";

const MySwal = withReactContent(Swal);

export default class CampaignsDeactivate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      id: props.id,
      loading: false,
      userSession: {},
      open: false,
    };
  }

  async componentDidMount() {
    this.setState({ userSession: this.context });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id || prevProps.value !== this.props.value) {
      this.setState({ userSession: this.context });
    }
  };

  updateCampaignStatus() {
    const url = `${process.env.REACT_APP_API_URL}/CampaingAPI/UpdateCampaingStatusPerId/${this.props.id}/${!this.props.value}`;

    acquireToken().then((token) => {
      axios
        .post(url, this.state.userSession, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.handleToggle();
            window.location.reload();
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while updating the campaign",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while updating the campaign",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
          }
        });
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.updateCampaignStatus();

    //data = JSON.stringify(this.state.js);
  };

  checkEmail = () => {};
  handleToggle = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  handlechange = (name) => ({ target: { value } }) => {
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { open, value } = this.state;
    return value ? (
      <Fragment>
        <Tooltip title="Archive this Campaign" onClick={this.handleToggle}>
          <IconButton
            style={{ backgroundColor: "#797991" }}
            aria-label="ArchiveCampaign"
          >
            <ArchiveIcon style={{ color: "#FFFFFF" }} />
          </IconButton>
        </Tooltip>

        <Dialog open={open} onClose={this.handleToggle} style={{ zIndex: 100 }}>
          <DialogTitle id="form-dialog-title">Archive Campaign</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you want to archive this campaign?
            </DialogContentText>
            <form onSubmit={this.handleSubmit}>
              <Grid container spacing={2}>
                <Grid item>
                  <Button type="submit" color="primary">
                    Archive
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    type="button"
                    color="secondary"
                    onClick={this.handleToggle}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </form>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </Fragment>
    ) : (
      <Fragment>
        <Tooltip title="Unarchive this Campaign" onClick={this.handleToggle}>
          <IconButton
            style={{ backgroundColor: "#797991" }}
            aria-label="UnarchiveCampaign"
          >
            <UnarchiveIcon style={{ color: "#FFFFFF" }} />
          </IconButton>
        </Tooltip>

        <Dialog open={open} onClose={this.handleToggle}>
          <DialogTitle id="form-dialog-title">Unarchive Campaign</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you want to unarchive this campaign?
            </DialogContentText>
            <form onSubmit={this.handleSubmit}>
              <Grid container spacing={2}>
                <Grid item>
                  <Button type="submit" color="primary">
                    Unarchive
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    type="button"
                    color="secondary"
                    onClick={this.handleToggle}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </form>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

CampaignsDeactivate.contextType = LoggedUserContext;
